// extracted by mini-css-extract-plugin
export default {"search":"css_search__d5YjE","icon":"css_icon__OPRMZ","spinner":"css_spinner__WqdfD","hint":"css_hint__uH-gH","input":"css_input__alBZv"};